import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${tokens.colors.dark3};
  border-radius: ${tokens.radius.large};
  gap: ${tokens.spacing.horizontalXsmall};
  height: 40px;
  cursor: pointer;
  width: 100%;
`

export const Icon = styled.img`
  height: 16px;
`

export const Text = styled.span`
  font-size: ${tokens.fontSize.medium};
  font-weight: ${tokens.fontWeights.bold};
  color: ${tokens.colors.dark5};
  text-align: center;
`
